import React from "react";

import {
    IWorkspaceResourceFolder,
    WorkspaceResourceFolderType,
    WorkspaceResourceType,
} from "common/interfaces";

import SideBar from "./SideBar";

export type ResourcePaneSideBarProps = {
    visible: boolean;
    readOnly?: boolean;
    resourceTypes: WorkspaceResourceType[];
    folderType?: WorkspaceResourceFolderType;
    createResourcesType?: WorkspaceResourceType;
    resourceFolders: IWorkspaceResourceFolder[];
    selectedFolderId?: string | null;
    draggedItems?: unknown[];
    onFolderDrop?: (folder: IWorkspaceResourceFolder) => void | Promise<void>;
    onSelectFolder?: (folderId: string | null) => void;
    children?: React.ReactNode;
};

function ResourcePaneSideBarComponent({
    visible,
    ...sideBarProps
}: ResourcePaneSideBarProps) {
    if (!visible) {
        return null;
    }

    return <SideBar {...sideBarProps} />;
}

export const ResourcePaneSideBar = React.memo(ResourcePaneSideBarComponent);
